import type React from 'react';

type DomainLayerType = 'L1' | 'L2' | 'L3' | 'L4' | 'L5';

const LAYER_NAMES: Record<DomainLayerType, string> = {
  L1: 'Identity',
  L2: 'Financial Core',
  L3: 'Behavioral Intelligence',
  L4: 'Vertical Domains',
  L5: 'Platform Services',
};

export interface LayerBadgeProps {
  layer: DomainLayerType;
  size?: 'sm' | 'md';
  showLabel?: boolean;
  className?: string;
}

export function LayerBadge({ layer, size = 'md', showLabel = false, className }: LayerBadgeProps): React.JSX.Element {
  const badgeClasses = ['layer-badge', `lb-${layer}`, size === 'sm' && 'sm', className]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={badgeClasses} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
      <span>{layer}</span>
      {showLabel && <span style={{ fontSize: 11, color: 'var(--text2)' }}>{LAYER_NAMES[layer]}</span>}
    </span>
  );
}
